{
  "familyId": "SPR-LEEN-LATIJN",
  "questions": [
    {
      "id": "SPR-LEEN-LATIJN-001",
      "familyId": "SPR-LEEN-LATIJN",
      "module": "SpellingRegel",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_latijn_mv",
      "questionType": "multiple_choice",
      "question": "Wat is het meervoud van 'museum'?",
      "context": "De klas bezoekt dit jaar drie verschillende ...",
      "options": ["musea", "museums", "museumen", "museum's"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Latijnse meervouden op -um → -a", "content": "Latijnse woorden op -um krijgen in het meervoud -a: museum → musea, aquarium → aquaria, podium → podia. Dit zijn vaste vormen die je uit je hoofd moet leren. Let op: 'museums' (Engels meervoud) en 'museum's' (met apostrof) zijn fout in het Nederlands.", "icon": "book" } }
      ],
      "conceptId": "latin_plural_um_a",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Museum is een Latijns leenwoord dat eindigt op -um. Regel: Latijnse woorden op -um krijgen in het meervoud -a. Dus: museum → musea. Andere voorbeelden: aquarium → aquaria, podium → podia, stadium → stadia. Het Engelse meervoud 'museums' en het apostrof-meervoud 'museum's' zijn in het Nederlands niet correct. Het Nederlandse meervoud 'museumen' (-en) is ook fout — bij Latijnse woorden geldt de Latijnse regel.",
        "solutionSteps": ["Herken: museum is een Latijns woord op -um", "Regel: Latijnse woorden op -um → meervoud -a", "museum → musea"],
        "distractorExplanations": {
          "0": "Goed! Latijns meervoud: -um wordt -a. Museum → musea.",
          "1": "Je gebruikte het Engelse meervoud 'museums' (met -s). In het Nederlands gebruiken we het Latijnse meervoud: musea. Regel: Latijnse woorden op -um → meervoud -a, niet -s.",
          "2": "Je voegde -en toe ('museumen'), maar dat is de gewone Nederlandse meervoudsregel. Bij Latijnse woorden op -um geldt een speciale regel: -um → -a. Onthoud: museum → musea, niet museumen.",
          "3": "Een apostrof gebruik je niet voor meervouden. 'Museum's' is een veelgemaakte fout. Het Latijnse meervoud is musea. Regel: nooit een apostrof bij meervoud, en Latijnse woorden op -um → -a."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "spr.latin-plural-english-s", "label": "Engels meervoud met -s", "optionIndex": 1 },
          { "id": "spr.latin-plural-dutch-en", "label": "Nederlands meervoud met -en", "optionIndex": 2 },
          { "id": "spr.latin-plural-apostrophe", "label": "Apostrof-meervoud", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-LEEN-LATIJN-002",
      "familyId": "SPR-LEEN-LATIJN",
      "module": "SpellingRegel",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_latijn_mv",
      "questionType": "multiple_choice",
      "question": "Welke zin is juist?",
      "options": [
        "In de stad zijn drie centrums.",
        "In de stad zijn drie centren.",
        "In de stad zijn drie centrum.",
        "In de stad zijn drie centra."
      ],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Centrum → centra", "content": "Centrum is een Latijns woord op -um. Het meervoud is centra (niet centrums). Dezelfde regel geldt voor: museum → musea, aquarium → aquaria, podium → podia.", "icon": "book" } }
      ],
      "conceptId": "latin_plural_centrum",
      "variantIndex": 2,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Centrum is een Latijns woord dat eindigt op -um. Het meervoud is centra, niet centrums of centren. De regel: Latijnse woorden op -um → meervoud -a. Dus: centrum → centra, net als museum → musea.",
        "solutionSteps": ["Herken: centrum is een Latijns woord op -um", "Regel: -um → -a in het meervoud", "centrum → centra"],
        "distractorExplanations": {
          "0": "Je gebruikte het Engelse meervoud 'centrums' (met -s). In het Nederlands is het centra (Latijns meervoud). Regel: Latijnse woorden op -um → meervoud -a, niet -s.",
          "1": "Je voegde -en toe: 'centren'. Maar bij Latijnse woorden op -um geldt: -um → -a. Onthoud: centrum → centra, niet centren. De Nederlandse -en regel geldt hier niet.",
          "2": "'Drie centrum' is enkelvoud. Bij 'drie' heb je het meervoud nodig: centra. Regel: Latijnse woorden op -um → meervoud -a.",
          "3": "Goed! Latijns meervoud: centrum → centra."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "spr.latin-plural-english-s", "label": "Engels meervoud met -s", "optionIndex": 0 },
          { "id": "spr.latin-plural-dutch-en", "label": "Nederlands meervoud met -en", "optionIndex": 1 },
          { "id": "spr.latin-plural-dutch-en", "label": "Enkelvoud i.p.v. meervoud", "optionIndex": 2 }
        ]
      }
    },
    {
      "id": "SPR-LEEN-LATIJN-003",
      "familyId": "SPR-LEEN-LATIJN",
      "module": "SpellingRegel",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_latijn_mv",
      "questionType": "fill_in",
      "question": "Vul het meervoud in: 'In het ziekenhuis zijn vijf ... waar je kunt wachten.' (podium)",
      "data": {
        "acceptedAnswers": ["podia"],
        "caseSensitive": false,
        "placeholder": "meervoud van podium"
      },
      "correctAnswer": "podia",
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Podium → podia", "content": "Podium is een Latijns woord op -um. Het meervoud is podia. Dezelfde regel: museum → musea, aquarium → aquaria, centrum → centra. Onthoud: -um wordt -a.", "icon": "book" } }
      ],
      "conceptId": "latin_plural_podium_fill",
      "variantIndex": 3,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Podium is een Latijns woord op -um. Het meervoud maak je door -um te vervangen door -a: podium → podia. Dit is dezelfde regel als bij museum → musea en centrum → centra. Het is een vaste vorm die je moet onthouden — je kunt hem niet afleiden uit de gewone Nederlandse meervoudsregels.",
        "solutionSteps": ["Herken: podium is een Latijns woord op -um", "Regel: -um → -a", "podium → podia"],
        "distractorExplanations": {}
      }
    },
    {
      "id": "SPR-LEEN-LATIJN-004",
      "familyId": "SPR-LEEN-LATIJN",
      "module": "SpellingRegel",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_latijn_mv",
      "questionType": "multiple_choice",
      "question": "Welk meervoud is NIET correct?",
      "options": [
        "musea",
        "podia",
        "aquariums",
        "centra"
      ],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Latijnse meervouden herkennen", "content": "Alle Latijnse woorden op -um krijgen meervoud -a: aquarium → aquaria (niet aquariums), museum → musea, podium → podia, centrum → centra. Het Engelse meervoud met -s is in het Nederlands niet correct.", "icon": "book" } }
      ],
      "conceptId": "latin_plural_fout_herkennen",
      "variantIndex": 4,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "'Aquariums' is niet correct — het juiste meervoud is 'aquaria'. Regel: Latijnse woorden op -um krijgen meervoud -a, niet het Engelse -s. Aquarium → aquaria. De andere drie (musea, podia, centra) zijn wél correcte Latijnse meervouden. Strategie: zie je een woord op -um? Vervang -um door -a voor het meervoud. Let op: het Engelse meervoud met -s (aquariums, museums, stadiums) is in het Nederlands fout.",
        "solutionSteps": ["Controleer elk woord: is het Latijnse meervoud correct?", "aquariums: FOUT — moet aquaria zijn (-um → -a)", "musea, podia, centra: allemaal correct (-um → -a)"],
        "distractorExplanations": {
          "0": "Musea is juist WEL correct: museum → musea. De -um wordt -a.",
          "1": "Podia is juist WEL correct: podium → podia. De -um wordt -a.",
          "2": "Goed! 'Aquariums' is fout. Het correcte Latijnse meervoud is aquaria.",
          "3": "Centra is juist WEL correct: centrum → centra. De -um wordt -a."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.latin-plural-english-s", "label": "Correct Latijns meervoud niet herkend", "optionIndex": 0 },
          { "id": "spr.latin-plural-english-s", "label": "Correct Latijns meervoud niet herkend", "optionIndex": 1 },
          { "id": "spr.latin-plural-english-s", "label": "Correct Latijns meervoud niet herkend", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-LEEN-LATIJN-005",
      "familyId": "SPR-LEEN-LATIJN",
      "module": "SpellingRegel",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_latijn_mv",
      "questionType": "multiple_choice",
      "question": "Welk woord volgt NIET de Latijnse meervoudsregel '-um wordt -a'?",
      "context": "Een dierentuin heeft veel bijzondere dieren.",
      "options": [
        "aquarium (meervoud: aquaria)",
        "album (meervoud: albums)",
        "stadium (meervoud: stadia)",
        "podium (meervoud: podia)"
      ],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Uitzonderingen op de Latijnse regel", "content": "Niet alle woorden op -um volgen de Latijnse meervoudsregel. 'Album' heeft als meervoud 'albums' (met -s), niet 'alba'. Dit komt doordat 'album' in het Nederlands als een gewoon woord wordt behandeld. Andere woorden zoals aquarium, stadium en podium volgen wél de Latijnse regel: -um → -a.", "icon": "book" } }
      ],
      "conceptId": "latin_plural_uitzondering",
      "variantIndex": 5,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "'Album' is een uitzondering: het meervoud is 'albums', niet 'alba'. Dit komt doordat 'album' in het dagelijks Nederlands zo gewoon is geworden dat het de Nederlandse meervoudsregel volgt (-s). Aquarium → aquaria, stadium → stadia en podium → podia volgen wél de Latijnse regel (-um → -a). Onthoud: de meeste Latijnse woorden op -um krijgen -a, maar er zijn uitzonderingen die je moet kennen.",
        "solutionSteps": ["Album → albums (uitzondering: gewone -s)", "Aquarium → aquaria (Latijnse regel: -um → -a)", "Stadium → stadia (Latijnse regel)", "Podium → podia (Latijnse regel)"],
        "distractorExplanations": {
          "0": "Aquarium volgt juist WEL de Latijnse regel: aquarium → aquaria (-um → -a).",
          "1": "Goed! 'Album' is een uitzondering: het meervoud is 'albums', niet 'alba'.",
          "2": "Stadium volgt juist WEL de Latijnse regel: stadium → stadia (-um → -a).",
          "3": "Podium volgt juist WEL de Latijnse regel: podium → podia (-um → -a)."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.latin-plural-english-s", "label": "Uitzondering niet herkend", "optionIndex": 0 },
          { "id": "spr.latin-plural-english-s", "label": "Uitzondering niet herkend", "optionIndex": 2 },
          { "id": "spr.latin-plural-english-s", "label": "Uitzondering niet herkend", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-LEEN-LATIJN-006",
      "familyId": "SPR-LEEN-LATIJN",
      "module": "SpellingRegel",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_latijn_mv",
      "questionType": "matching",
      "question": "Koppel elk Latijns leenwoord aan het juiste meervoud.",
      "data": {
        "pairs": [
          { "left": "museum", "right": "musea" },
          { "left": "aquarium", "right": "aquaria" },
          { "left": "podium", "right": "podia" },
          { "left": "stadium", "right": "stadia" },
          { "left": "centrum", "right": "centra" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Latijnse meervouden: -um → -a",
            "content": "Latijnse woorden op -um krijgen in het meervoud -a. Dit is een vaste regel: museum → musea, aquarium → aquaria, podium → podia, stadium → stadia, centrum → centra.",
            "icon": "book"
          }
        }
      ],
      "conceptId": "latin_plural_matching",
      "variantIndex": 6,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Alle Latijnse woorden op -um krijgen meervoud -a: museum → musea, aquarium → aquaria, podium → podia, stadium → stadia, centrum → centra.",
        "solutionSteps": [
          "Herken de regel: Latijns woord op -um → meervoud -a",
          "Vervang -um door -a bij elk woord",
          "museum → musea, aquarium → aquaria, enz."
        ]
      }
    },
    {
      "id": "SPR-LEEN-LATIJN-007",
      "familyId": "SPR-LEEN-LATIJN",
      "module": "SpellingRegel",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_latijn_mv",
      "questionType": "matching",
      "question": "Koppel elk Latijns woord aan de juiste meervoudsregel.",
      "data": {
        "pairs": [
          { "left": "museum → musea", "right": "-um → -a" },
          { "left": "index → indices", "right": "-ex → -ices" },
          { "left": "cactus → cacti", "right": "-us → -i" },
          { "left": "basis → bases", "right": "-is → -es" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Latijnse meervoudsregels",
            "content": "Latijnse woorden hebben verschillende meervoudsregels: -um → -a (museum → musea), -us → -i (cactus → cacti), -ex → -ices (index → indices), -is → -es (basis → bases).",
            "icon": "book"
          }
        }
      ],
      "conceptId": "latin_plural_rules_matching",
      "variantIndex": 7,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Latijn heeft meerdere meervoudsregels: -um → -a (musea), -us → -i (cacti), -ex → -ices (indices), -is → -es (bases). Elke uitgang heeft zijn eigen meervoudsvorm.",
        "solutionSteps": [
          "Kijk naar de uitgang van het enkelvoud",
          "-um → -a, -us → -i, -ex → -ices, -is → -es",
          "Koppel elk voorbeeld aan de juiste regel"
        ]
      }
    },
    {
      "id": "SPR-LEEN-LATIJN-008",
      "familyId": "SPR-LEEN-LATIJN",
      "module": "SpellingRegel",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_latijn_mv",
      "questionType": "fill_in",
      "question": "Vul het juiste Latijnse meervoud in: 'In de stad zijn meerdere ___.' (aquarium)",
      "correctAnswer": "aquaria",
      "data": {
        "acceptedAnswers": ["aquaria"],
        "placeholder": "meervoud van aquarium"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Latijns meervoud: -um → -a",
            "content": "Latijnse woorden op -um krijgen meervoud -a. Aquarium → aquaria. Net als museum → musea en podium → podia.",
            "icon": "book"
          }
        }
      ],
      "conceptId": "latin_plural_fill_in",
      "variantIndex": 8,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Aquarium is een Latijns leenwoord dat eindigt op -um. De regel: Latijnse woorden op -um krijgen in het meervoud -a. Dus: aquarium → aquaria. Dezelfde regel geldt voor museum → musea, podium → podia en centrum → centra.",
        "solutionSteps": [
          "Herken: aquarium eindigt op -um → Latijns woord",
          "Regel: -um → -a",
          "aquarium → aquaria"
        ]
      }
    },
    {
      "id": "SPR-LEEN-LATIJN-009",
      "familyId": "SPR-LEEN-LATIJN",
      "module": "SpellingRegel",
      "tier": 15,
      "levelCode": "E8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_latijn_mv",
      "questionType": "true_false_series",
      "question": "Beoordeel of elk meervoud correct is.",
      "data": {
        "statements": [
          { "text": "Het meervoud van 'museum' is 'musea'.", "isTrue": true },
          { "text": "Het meervoud van 'aquarium' is 'aquariums'.", "isTrue": false },
          { "text": "Het meervoud van 'album' is 'albums'.", "isTrue": true },
          { "text": "Het meervoud van 'stadium' is 'stadiums'.", "isTrue": false },
          { "text": "Het meervoud van 'podium' is 'podia'.", "isTrue": true }
        ]
      },
      "correctAnswer": [true, false, true, false, true],
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Latijnse meervouden", "content": "Latijnse woorden op -um krijgen meervoud -a: museum → musea, aquarium → aquaria, stadium → stadia, podium → podia. Uitzondering: 'album' → 'albums' (gewone -s). Het Engelse meervoud met -s (aquariums, stadiums) is in het Nederlands fout.", "icon": "book" } }],
      "conceptId": "latin_plural_tf_series",
      "variantIndex": 9,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Regel: Latijnse woorden op -um krijgen meervoud -a. Museum → musea ✓, aquarium → aquaria (niet aquariums ✗), stadium → stadia (niet stadiums ✗), podium → podia ✓. Uitzondering: 'album' → 'albums' ✓ — dit woord is zo ingeburgerd dat het de Nederlandse meervoudsregel volgt. De sleutel is: ken de regel (-um → -a) én de uitzonderingen (album). Het Engelse meervoud met -s is in het Nederlands fout bij de meeste Latijnse woorden.",
        "solutionSteps": [
          "Museum → musea: Latijnse regel -um → -a → correct ✓",
          "Aquarium → aquariums: Engels meervoud → fout (aquaria)",
          "Album → albums: uitzondering, gewone -s → correct ✓",
          "Stadium → stadiums: Engels meervoud → fout (stadia)",
          "Podium → podia: Latijnse regel -um → -a → correct ✓"
        ]
      },
      "pedagogy": {
        "dok": 3
      }
    }
  ]
}